/* eslint-disable no-plusplus */

function itemsToColumns(items, nColumns) {
  if (!Array.isArray(items) || nColumns < 1) return [];
  const columns = [];
  const itemsPerColumn = Math.ceil(items.length / nColumns);
  for (let i = 0; i < nColumns; i++) {
    const start = i * itemsPerColumn;
    const end = start + itemsPerColumn;
    columns.push(items.slice(start, end));
  }
  return columns;
}

export default itemsToColumns;
